import {client} from './api-client'

function search(url: string, include?: string, signal?: any) {
  return client(`${url}${include ? `&$include=${include}` : ''}`, {customConfig: { signal }})
}

export {search}
